import React from 'react';
import TutorialSteps from '../../../components/utilities/tutorialSteps/TutorialSteps';
import GhostSunburst from '../../../resources/svg/anomaly_sunburst_empty_state.svg';
import css from './SunburstEmptyState.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANOMALY_ANALYSIS.SUNBURST';

const STEP_KEYS = ['EMPTY_STEP_CONFIGURE', 'EMPTY_STEP_EXPLORE', 'EMPTY_STEP_INVESTIGATE'];

const SunburstEmptyState = () => (
    <TutorialSteps
        icon={<GhostSunburst className={css.heroGraphic} />}
        title={`${TRANSLATION_PREFIX}.EMPTY_TITLE`}
        subtitle={`${TRANSLATION_PREFIX}.EMPTY_SUBTITLE`}
        steps={STEP_KEYS.map(stepKey => `${TRANSLATION_PREFIX}.${stepKey}`)}
    />
);

export default SunburstEmptyState;
